var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { css, html, LitElement } from "lit";
import { defaults, onSurfaceColor, primaryColor, surfaceContainerColor } from "../style";
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
export const helpCardTranslations = {
    "title": "Drag the slider to walk through your code.",
    "text_1": "This window shows how your program works step by step. Explore to see how your program builds and stores information.",
    "text_2": "You can also use the %{previous} and %{next} buttons to go to the previous or next step. The %{first} and %{last} buttons can be used to directly jump to the first or last step respectively."
};
function fillTemplate(template, params) {
    for (const param in params) {
        template = template.replace(`%{${param}}`, params[param]);
    }
    return template;
}
let HelpCard = class HelpCard extends LitElement {
    constructor() {
        super(...arguments);
        this.translations = helpCardTranslations;
    }
    render() {
        return html `
            <h3>
                <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" width="22"><path d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                ${this.translations.title}
            </h3>
            <p>
                <em>${this.translations.text_1}</em>
            </p>
            <p>
                ${unsafeHTML(fillTemplate(this.translations.text_2, {
            next: "<span class=\"button\">></span>",
            previous: "<span class=\"button\"><</span>",
            last: "<span class=\"button\">>></span>",
            first: "<span class=\"button\"><<</span>"
        }))}
            </p>
        `;
    }
};
HelpCard.styles = [defaults, css `
      :host {
        width: 360px;
        border-radius: 10px;
        padding: 20px;
        display: block;
        background-color: ${surfaceContainerColor};
        font-size: 14px;
      }
      
      .button {
        display: inline-block;
        width: 25px;
        text-align: center;
        color: ${primaryColor};
        font-size: 16px;
      }
      h3{
        display: flex;
        align-items: center;
        margin-top: 0;
      }
      
      svg {
        margin-right: 10px;
        fill: ${onSurfaceColor};
      }
    `];
__decorate([
    property({ type: Object })
], HelpCard.prototype, "translations", void 0);
HelpCard = __decorate([
    customElement('tc-help-card')
], HelpCard);
export { HelpCard };
//# sourceMappingURL=HelpCard.js.map